<template>
  <div id="mer" class="container-fluid m-0 p-0">
    <MatrizMenu />
    <div class="pl-2 pr-2">
      <div class="bg-light matriz-peligro-content col-md-12">
        <div class="collapse show" id="mer-collapse">
          <div
            class="encabezado"
            v-show="!$store.state.global_id_matriz_riesgo"
          >
            <h5 class="color_letra--encabezado">Contenido No Disponible</h5>
            <div class="dropdown">
              <span class="badge text-secondary dropbtn"
                ><i class="fas fa-question-circle fa-lg"></i
              ></span>
              <div class="dropdown_content">
                <p>
                  En este momento usted no tiene un Centro de Trabajo
                  seleccionado o no está con un peligro específico
                </p>
                <p>
                  Para seleccionar un Centro de Trabajo, diríjase a la sección
                  <b>Lista Centro de Trabajo</b>, opciones del Centro de
                  Trabajo, <b>Editar</b>
                </p>
                <p>
                  Para seleccionar un peligro específico, en este mismo módulo,
                  en opciones de la lista de matrices peligro, <b>Editar</b>
                </p>
              </div>
            </div>
          </div>

          <form v-on:submit.prevent="accion_formulario" class="mt-3">
            <div class="row justify-content-center">
              <div class="col-lg-5 border-right">
                <div class="form-row">
                  <label class="color_letra text-center col-lg-12"
                    >PROBABILIDAD<span class="badge text-secondary"
                      ><i
                        class="fas fa-question-circle fa-lg"
                        data-toggle="tooltip"
                        data-placement="right"
                        data-html="true"
                        title=""
                      ></i></span></label
                  ><br />
                  <div class="col-lg-3">
                    <label class="color_letra"
                      >Nivel de Deficiencia: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title="Fuente, situación o acto con potencial de daños en términos de enfermedad o lesión a las personas, o una combinación de estos."
                        ></i></span
                    ></label>
                    <select
                      class="form-control form-control-sm btn_general"
                      v-model="c_nivel_eficiencia"
                      title="NIVEL DE DEFICIENCIA
                                            10: Pel. con consec. muy signi.
                                                o la eficacia del conjunto de
                                                medidas es nula, o ambos.
                                            6: Pel. con consec. o la eficacia
                                                del conjunto de medidas es bajo,
                                                o ambos.
                                            2: Pel. con consec. poco signi.
                                                o la eficacia del conjunto de
                                                medidas es moderado."
                      @change="sumarr()"
                      required
                    >
                      <option disabled selected value="">Selección</option>
                      <option value="10">10</option>
                      <option value="6">6</option>
                      <option value="2">2</option>
                      <option value="0">No se Asigna Valor</option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label class="color_letra text-lg-left"
                      >Nivel de Exposición: *<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title=""
                        ></i></span
                    ></label>
                    <select
                      class="form-control form-control-sm btn_general"
                      v-model="c_nivel_exposicion"
                      title="NIVEL DE EXPOSICIÓN
                                            4: Continua - Sin interrupción o
                                            varias veces con tiempo prolongado
                                            durante la jornada.
                                            3: Frecuente - Varias veces durante
                                            la jornada por tiempos cortos.
                                            2: Ocasional - Algunas veces durante 
                                            la jornada y por un período de
                                            tiempo corto.
                                            1: Esporádica - De manera eventual."
                      @change="sumarr()"
                      :disabled="c_nivel_eficiencia == 0"
                      required
                    >
                      <option disabled selected value="">Selección</option>
                      <option value="4">4</option>
                      <option value="3">3</option>
                      <option value="2">2</option>
                      <option value="1">1</option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label class="color_letra text-lg-left"
                      >Nivel de Probabilidad:<span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title=""
                        ></i></span
                    ></label>
                    <input
                      type="text"
                      v-model="c_nivel_probabilidad"
                      class="form-control form-control-sm btn_general"
                      readonly
                      required
                    />
                  </div>

                  <!-- INTERPRETACIÓN -->
                  <div class="col-lg-3">
                    <label class="color_letra"
                      >Interpretación:
                      <span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title=""
                        ></i></span
                    ></label>
                    <input
                      type="text"
                      v-model="c_interpretacion"
                      class="
                        form-control form-control-sm
                        btn_general
                        font-weight-bold
                      "
                      :style="class_btn_outline"
                      readonly
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-5 border-right">
                <label class="color_letra text-center"
                  >RIESGO<span class="badge text-secondary"
                    ><i
                      class="fas fa-question-circle fa-lg"
                      data-toggle="tooltip"
                      data-placement="right"
                      data-html="true"
                      title=""
                    ></i></span
                ></label>
                <div class="form-row">
                  <!-- CONSECUENCIA -->
                  <div class="col-lg-4">
                    <label class="color_letra"
                      >Nivel de Consecuencia:
                      <span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title=""
                        ></i></span
                    ></label>
                    <select
                      class="form-control form-control-sm btn_general"
                      v-model="c_nivel_consecuencia"
                      title="NIVEL DE CONSECUENCIA
                                            100: Muerte(s).
                                            60: Lesiones o enfermedades graves
                                                irreparables (incapacidad permanente,
                                                parcial o invalidez.
                                            25: Lesiones o enfermedades con
                                                incapacidad laboral temporal.
                                            10: Lesiones o enfermedades que
                                                no requieren incapacidad."
                      @change="sumarr()"
                      :disabled="c_nivel_eficiencia == 0"
                      required
                    >
                      <option disabled selected value="">Selección</option>
                      <option value="100">100</option>
                      <option value="60">60</option>
                      <option value="25">25</option>
                      <option value="10">10</option>
                    </select>
                  </div>

                  <!-- NR -->
                  <div class="col-lg-4">
                    <br /><label class="color_letra"
                      >Nivel de Riesgo:
                      <span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title=""
                        ></i></span
                    ></label>
                    <input
                      class="form-control form-control-sm btn_general"
                      v-model="c_nivel_riesgo"
                      readonly
                      required
                    />
                  </div>

                  <!-- INTERPRETACIÓN NR -->
                  <div class="col-lg-4">
                    <br /><label class="color_letra"
                      >Interpretación del NR:
                      <span class="badge text-secondary"
                        ><i
                          class="fas fa-question-circle fa-lg"
                          data-toggle="tooltip"
                          data-placement="right"
                          data-html="true"
                          title=""
                        ></i></span
                    ></label>
                    <input
                      type="text"
                      v-model="c_interpretacion_nr"
                      class="
                        form-control form-control-sm
                        btn_general
                        interpretacion-nr
                        font-weight-bold
                      "
                      readonly
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-2">
                <label class="color_letra text-center"
                  >VALORACIÓN DEL RIESGO<span class="badge text-secondary"
                    ><i
                      class="fas fa-question-circle fa-lg"
                      data-toggle="tooltip"
                      data-placement="right"
                      data-html="true"
                      title=""
                    ></i></span
                ></label>
                <!-- VR -->
                <div class="col-lg-12">
                  <label class="color_letra"
                    >Aceptabilidad del Riesgo:
                    <span class="badge text-secondary"
                      ><i
                        class="fas fa-question-circle fa-lg"
                        data-toggle="tooltip"
                        data-placement="right"
                        data-html="true"
                        title=""
                      ></i></span
                  ></label>
                  <input
                    type="text"
                    v-model="c_aceptabilidad"
                    class="
                      form-control form-control-sm
                      btn_general
                      font-weight-bold
                    "
                    :style="class_btn_alerts"
                    readonly
                    required
                  />
                </div>
              </div>
            </div>
            <div class="row justify-content-center pt-5">
              <button
                v-show="$store.state.msp_c_key"
                type="button"
                @click="terminar_centro_trabajo"
                class="btn btn-sm btn-form font-weight-bold"
              >
                TERMINAR MATRIZ DE PELIGROS
              </button>
              <button
                v-show="$store.state.global_id_matriz_riesgo"
                type="button"
                @click="
                  es_guardar = false;
                  accion_formulario();
                "
                class="btn btn-sm btn-form font-weight-bold"
              >
                TERMINAR
              </button>
              <button
                type="submit"
                @click="es_guardar = true"
                class="btn btn-sm btn-form font-weight-bold"
                :disabled="!$store.state.global_id_matriz_riesgo"
              >
                GUARDAR
              </button>
            </div>
          </form>
        </div>
        <div class="d-flex justify-content-end m-0 p-0">
          <a
            @click="collapsed = !collapsed"
            class="pb-0 mb-0"
            data-toggle="collapse"
            data-target="#mer-collapse"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            <i
              :class="[collapsed ? 'fa-chevron-up' : 'fa-chevron-down', 'fa']"
            ></i>
          </a>
        </div>
      </div>
    </div>
    <Mtm />
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import MatrizMenu from "@/components/MatrizMenu.vue";
import Mtm from "@/components/Mtm.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "mer",
  components: {
    MatrizMenu,
    Mtm,
  },
  data() {
    return {
      collapsed: true,
      c_nivel_eficiencia: null,
      c_nivel_consecuencia: null,
      c_nivel_exposicion: null,
      c_nivel_probabilidad: 0,
      c_interpretacion: "",

      c_nivel_riesgo: 0,
      c_interpretacion_nr: 0,
      c_aceptabilidad: "",

      class_btn_alerts: {
        border: "",
        textAlign: "center",
        color: "",
      },
      class_btn_outline: {
        border: "",
        textAlign: "center",
        color: "",
      },
      es_guardar: false,
    };
  },
  created() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.limpiar_variables();
    if (this.$store.state.global_id_matriz_riesgo) {
      // CARGAR DATOS DE LA BASE matriz_riesgo
      if (!this.$store.state.global_nuevo_peligro) {
        const docRef = db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo);
        docRef
          .get()
          .then((doc) => {
            this.c_nivel_eficiencia = doc.data().em_nivel_eficiencia;
            this.c_nivel_consecuencia = doc.data().em_nivel_consecuencia;
            this.c_nivel_exposicion = doc.data().em_nivel_exposicion;
            this.c_nivel_probabilidad = doc.data().em_nivel_probabilidad;
            this.c_interpretacion = doc.data().em_interpretacion;

            this.c_nivel_riesgo = doc.data().em_nivel_riesgo;
            this.c_interpretacion_nr = doc.data().em_interpretacion_nr;
            this.c_aceptabilidad = doc.data().em_aceptabilidad;

            if (!this.c_aceptabilidad || this.c_aceptabilidad == "") {
              this.c_aceptabilidad = "Pendiente";

              this.class_btn_alerts.border = "3px solid #5bc0de";
              this.class_btn_alerts.color = "#5bc0de";
            } else {
              if (this.c_aceptabilidad == "No Aceptable") {
                this.class_btn_alerts.border = "3px solid #d9534f";
                this.class_btn_alerts.color = "#d9534f";
              } else if (
                this.c_aceptabilidad == "Aceptable con Control Específico"
              ) {
                this.class_btn_alerts.border = "3px solid #f0ad4e";
                this.class_btn_alerts.color = "#f0ad4e";
              } else if (this.c_aceptabilidad == "Mejorable") {
                this.class_btn_alerts.border = "3px solid #5cb85c";
                this.class_btn_alerts.color = "#5cb85c";
              } else if (this.c_aceptabilidad == "Aceptable") {
                this.class_btn_alerts.border = "3px solid #5cb85c";
                this.class_btn_alerts.color = "#5cb85c";
              }
            }
            if (!this.c_interpretacion || this.c_interpretacion == "") {
              this.c_interpretacion = "Pendiente";
              this.class_btn_outline.border = "3px solid #5bc0de";
              this.class_btn_outline.color = "#5bc0de";
            } else {
              if (this.c_interpretacion == "Muy alto") {
                this.class_btn_outline.border = "3px solid #d9534f";
                this.class_btn_outline.color = "#d9534f";
              } else if (this.c_interpretacion == "Alto") {
                this.class_btn_outline.border = "3px solid #f0ad4e";
                this.class_btn_outline.color = "#f0ad4e";
              } else if (this.c_interpretacion == "Medio") {
                this.class_btn_outline.border = "3px solid #5cb85c";
                this.class_btn_outline.color = "#5cb85c";
              } else if (this.c_interpretacion == "Bajo") {
                this.class_btn_outline.border = "3px solid #5cb85c";
                this.class_btn_outline.color = "#5cb85c";
              }
            }
          })
          .catch((error) => {
            console.log(
              "Error obteniendo el documento para ser editado.",
              error
            );
          });
      }
    }
  },
  methods: {
    terminar_centro_trabajo() {
      NProgress.start();
      this.limpiar_variables();
      this.$store.commit("mutation_limpiar_globales");
      NProgress.done();
      NProgress.remove();
    },

    async accion_formulario() {
      await NProgress.start();
      if (this.es_guardar) {
        if (
          this.$store.state.msp_c_key &&
          this.$store.state.global_id_matriz_riesgo
        ) {
          this.guardar_evaluacion_riesgo();
        }
      } else {
        this.limpiar_variables();
        this.$store.state.global_id_matriz_riesgo = "";
        this.$store.state.global_es_editar = false;
        this.$store.state.global_nuevo_peligro = false;
        this.limpiar_variables_globales();
        NProgress.done();
        NProgress.remove();
      }
    },

    async guardar_evaluacion_riesgo() {
      if (this.c_aceptabilidad == "Pendiente") {
        this.c_aceptabilidad = "";
      }
      if (this.c_interpretacion == "Pendiente") {
        this.c_interpretacion = "";
      }
      await db
        .collection("matriz_riesgo")
        .doc(this.$store.state.global_id_matriz_riesgo)
        .update({
          em_nivel_eficiencia: this.c_nivel_eficiencia,
          em_nivel_exposicion: this.c_nivel_exposicion,
          em_nivel_probabilidad: this.c_nivel_probabilidad,
          em_interpretacion: this.c_interpretacion,
          em_nivel_consecuencia: this.c_nivel_consecuencia,
          em_nivel_riesgo: this.c_nivel_riesgo,
          em_interpretacion_nr: this.c_interpretacion_nr,
          em_aceptabilidad: this.c_aceptabilidad,
        });
      await this.limpiar_variables();
      NProgress.done();
      NProgress.remove();
      const tap1 = document.querySelector("#mer-tab");
      tap1.classList.remove("active");
      tap1.setAttribute("aria-selected", false);

      const tap2 = document.getElementById("mmi-tab");
      tap2.setAttribute("aria-selected", true);
      this.$router.push("/medidas_intervencion");
    },

    // EVALUACIÓN DEL RIESGO
    sumarr() {
      if (this.c_nivel_eficiencia == 0) {
        this.c_nivel_exposicion = 0;
        this.c_nivel_consecuencia = 0;
      }
      this.c_nivel_probabilidad =
        this.c_nivel_eficiencia * this.c_nivel_exposicion;
      if (this.c_nivel_probabilidad >= 24) {
        this.c_interpretacion = "Muy alto";
        this.class_btn_outline.border = "3px solid #d9534f";
        this.class_btn_outline.color = "#d9534f";
      }
      if (this.c_nivel_probabilidad >= 10 && this.c_nivel_probabilidad <= 20) {
        this.c_interpretacion = "Alto";
        this.class_btn_outline.border = "3px solid #f0ad4e";
        this.class_btn_outline.color = "#f0ad4e";
      }
      if (this.c_nivel_probabilidad >= 6 && this.c_nivel_probabilidad <= 8) {
        this.c_interpretacion = "Medio";
        this.class_btn_outline.border = "3px solid #5cb85c";
        this.class_btn_outline.color = "#5cb85c";
      }
      if (this.c_nivel_probabilidad >= 0 && this.c_nivel_probabilidad <= 4) {
        this.c_interpretacion = "Bajo";
        this.class_btn_outline.border = "3px solid #5cb85c";
        this.class_btn_outline.color = "#5cb85c";
      }

      if (this.c_nivel_consecuencia == "0" || this.c_nivel_probabilidad == 0) {
        this.c_nivel_riesgo = 20;
      } else {
        this.c_nivel_riesgo =
          this.c_nivel_probabilidad * this.c_nivel_consecuencia;
      }

      if (this.c_nivel_riesgo >= 600 && this.c_nivel_riesgo <= 4000) {
        this.c_interpretacion_nr = "l";
        this.c_aceptabilidad = "No Aceptable";
        this.class_btn_alerts.border = "3px solid #d9534f";
        this.class_btn_alerts.color = "#d9534f";
      } else if (this.c_nivel_riesgo >= 150 && this.c_nivel_riesgo <= 500) {
        this.c_interpretacion_nr = "ll";
        this.c_aceptabilidad = "Aceptable con Control Específico";
        this.class_btn_alerts.border = "3px solid #f0ad4e";
        this.class_btn_alerts.color = "#f0ad4e";
      } else if (this.c_nivel_riesgo >= 40 && this.c_nivel_riesgo <= 120) {
        this.c_interpretacion_nr = "lll";
        this.c_aceptabilidad = "Mejorable";
        this.class_btn_alerts.border = "3px solid #5cb85c";
        this.class_btn_alerts.color = "#5cb85c";
      } else if (this.c_nivel_riesgo == 0 || this.c_nivel_riesgo == 20) {
        this.c_interpretacion_nr = "lV";
        this.c_aceptabilidad = "Aceptable";
        this.class_btn_alerts.border = "3px solid #5cb85c";
        this.class_btn_alerts.color = "#5cb85c";
      }
    },

    limpiar_variables() {
      this.c_nivel_eficiencia = null;
      this.c_nivel_consecuencia = null;
      this.c_nivel_exposicion = null;
      this.c_nivel_probabilidad = 0;
      this.c_interpretacion = "";

      this.c_nivel_riesgo = 0;
      this.c_interpretacion_nr = 0;
      this.c_aceptabilidad = "";
      this.class_btn_alerts = {
        border: "",
        textAlign: "center",
        color: "",
      };
      this.class_btn_outline = {
        border: "",
        textAlign: "center",
        color: "",
      };
      this.es_guardar = false;
    },

    limpiar_variables_globales() {
      this.$store.state.mip_id_proceso = "";
      this.$store.state.mip_id_zona = "";
      this.$store.state.mip_id_actividad = "";
      this.$store.state.mip_id_tareas = "";
      this.$store.state.mip_proceso = "";
      this.$store.state.mip_zona = "";
      this.$store.state.mip_actividad = "";
      this.$store.state.mip_tarea = [];
      this.$store.state.mip_rutinario = "";
    },

    toggleIcon() {
      let iconClass = document.getElementById("icon-collapse");

      if (iconClass.classList) {
        iconClass.classList.toggle("fa-chevron-up");
      } else {
        var classes = iconClass.className.split(" ");
        var i = classes.indexOf("fa-chevron-down");

        if (i >= 0) classes.splice(i, 1);
        else classes.push("fa-chevron-up");
        iconClass.className = classes.join(" ");
      }
    },
  },
};
</script>